const SpaceBubbles = () => {
  return (
    <svg
      width="25"
      height="20"
      viewBox="0 0 25 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M24.9994 9.95086C24.9994 15.4466 20.5442 19.9017 15.0485 19.9017C9.55281 19.9017 5.09766 15.4466 5.09766 9.95086C5.09766 4.45515 9.55281 0 15.0485 0C20.5442 0 24.9994 4.45515 24.9994 9.95086ZM18.6547 7.37601C18.6547 9.64539 17.0449 11.4851 15.0592 11.4851C13.0735 11.4851 11.4638 9.64539 11.4638 7.37601C11.4638 5.10664 13.0735 3.26694 15.0592 3.26694C17.0449 3.26694 18.6547 5.10664 18.6547 7.37601ZM9.40879 15.3359C9.40879 10.0967 20.7087 10.3091 20.7087 15.3358C17.401 18.955 12.3402 18.4161 9.40879 15.3359Z"
        fill="#023A4A"
        className="fs-switch-colour"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.3217 19.9011C6.43436 18.2649 3.70508 14.42 3.70508 9.93768C3.70508 5.48134 6.40278 1.65509 10.2542 0.00292969C4.86013 0.119994 0.523438 4.52926 0.523438 9.95141C0.523438 15.3962 4.89636 19.8196 10.3217 19.9011Z"
        fill="#023A4A"
        className="fs-switch-colour"
      />
    </svg>
  );
};

export default SpaceBubbles;
